import { BlockReason, useConnectivityNotice } from './requiresInternet';

/** Item de `Flashbar` do Cloudscape (formato estrutural — o ui-shared não depende do Cloudscape). */
export type ConnectivityFlashItem = {
  readonly id: 'connectivity';
  readonly type: 'warning';
  readonly content: string;
  readonly dismissible: false;
};

/**
 * Item do `Flashbar` para o admin e o CRM (100% Cloudscape, sem Tailwind).
 *
 * Origem: #1010 — 2026-10-20 15:22 +0200.
 *
 * Contrato: `null` quando está tudo bem; senão o item de aviso com o texto do
 * motivo. Quem usa coloca como PRIMEIRO item da `notifications` do
 * `AppLayout` (topo do conteúdo, sob a barra superior). Mesmo critério do
 * `ConnectivityBanner` do `apps/app`: só `OFFLINE` confirmado ou hora do
 * servidor pendente — `UNKNOWN` no boot não aparece.
 *
 * Usado por: `AdminLayout.tsx` e `CrmLayout.tsx`.
 */
export function useConnectivityFlashItem(texts: {
  offlineText: string;
  clockPendingText: string;
}): ConnectivityFlashItem | null {
  const reason = useConnectivityNotice();
  if (reason === null) return null;
  return {
    id: 'connectivity',
    type: 'warning',
    content: reason === BlockReason.OFFLINE ? texts.offlineText : texts.clockPendingText,
    dismissible: false,
  };
}
